import { useDisclosure } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Modal, OpenModal } from "../../../components/Modal";
import Builder from "../../../components/forms";
import { toast } from "react-toastify";
import { withdrawApi } from "../../../api";
import { useDispatch } from "react-redux"; 
import types from "../../../redux/withdraw/actionTypes";


export const Edit = ({ withdraw = false }) => {
  const disclousure = useDisclosure();
  const [fields, setFields] = useState([]);

  const dispatch = useDispatch();

  const getWithdrawalsAsync = async () => {
    const response = await withdrawApi.withdrawals();
    dispatch(types.getWithdrawals(response.data.data));
  };

  const editWithdrawal = async (data) => {
    const response = await withdrawApi.editWithdrawal(withdraw.id, data);
    if (response?.data) {
      toast.success(`Retiro editado correctamente`, { theme: "dark" });
      getWithdrawalsAsync();
      disclousure?.onClose();
    }
  };

  useEffect(() => {
    if (withdraw) {
      setFields([
        {
          name: "rate",
          label: "Editar rate",
          defaultValue: withdraw.rate,
          required: true,
        },
      ]);
    }
  }, [withdraw]);

  return (
    <>
      <OpenModal  text="Editar retiro" icon="" disclousure={disclousure} />

      <Modal  isOpen={disclousure.isOpen} onClose={disclousure.onClose}>
        <Builder fields={fields} message="Editar" onClick={editWithdrawal} />
      </Modal>
    </>
  );
};
